export enum PartyRenewal {
    AlreadyRenewed= 0,
    CanRenew = 1,
    MustRenew = 2,
    CannotRenew = 3
}